import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

// Enterprise Status Page Routes
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE = `${URL_APP_ADMIN}/enterprise-status-page`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/create-incident`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/incident/:incidentId`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_USER_GROUPS = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/user-groups`

// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  | 'app-admin-enterprise-status-page'
  | 'app-admin-enterprise-status-page-create-incident'
  | 'app-admin-enterprise-status-page-incident-details'
  | 'app-admin-enterprise-status-page-user-groups'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-enterprise-status-page': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE,
  'app-admin-enterprise-status-page-create-incident':
    URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT,
  'app-admin-enterprise-status-page-incident-details':
    URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS,
  'app-admin-enterprise-status-page-user-groups': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_USER_GROUPS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
